/** PELU-07: helpers for multi-service appointment totals. */

export type AppointmentItemLike = {
  productId: string;
  nameSnapshot?: string;
  priceSnapshot: number;
  durationMinutes: number;
  sortOrder?: number;
};

export function sumAppointmentItemDurations(
  items: Array<{ durationMinutes: number }>,
): number {
  return items.reduce((acc, i) => acc + Math.max(0, Number(i.durationMinutes) || 0), 0);
}

export function sumAppointmentItemPrices(
  items: Array<{ priceSnapshot?: number; price?: number }>,
): number {
  return items.reduce((acc, i) => {
    const p = i.priceSnapshot ?? i.price ?? 0;
    return acc + (Number.isFinite(p) ? Number(p) : 0);
  }, 0);
}

export function appointmentItemsToRpcPayload(
  productIds: string[],
): Array<{ product_id: string }> {
  return productIds.filter(Boolean).map((product_id) => ({ product_id }));
}

export function formatAppointmentServicesLabel(
  items: Array<{ nameSnapshot?: string; name?: string }>,
  fallback = 'Servicio',
): string {
  const names = items
    .map((i) => (i.nameSnapshot ?? i.name ?? '').trim())
    .filter(Boolean);
  if (names.length === 0) return fallback;
  if (names.length === 1) return names[0]!;
  if (names.length === 2) return `${names[0]} + ${names[1]}`;
  return `${names[0]} + ${names.length - 1} más`;
}
